// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.manual-review-detail-page {
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
  padding: 24px 30px;
}

.manual-review-detail-page .manual-review-page__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.manual-review-detail-page .manual-review-page__header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.manual-review-detail-page .manual-review-page__title {
  margin: 0;
  font-size: var(--sub-header-FontSize);
  font-weight: var(--header-FontWeight);
  color: var(--countValueFontColor);
}

.manual-review-detail-page .manual-review-page__back-icon {
  cursor: pointer;
}

.manual-review-detail-page .manual-review-page__header-right {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}
.manual-review-detail-page .manual-hold-Icon.reactSvgDiv div {
  display: flex;
  align-items: center;
}

.manual-review-detail-page .manual-review-page__action-label {
  color: var(--popupTItleColor);
  font-weight: var(--header-FontWeight);
}

.manual-review-detail-page .manual-review-page__status {
  font-size: var(--caseSubHeading-FontSize);
  color: var(--popupTItleColor);
  font-weight: var(--header-FontWeight);
}

.manual-review-detail-page .manual-review-page__tabs {
  height: 100%;
  overflow: hidden;
}

.manual-review-detail-page .manual-review__events-tab {
  height: 100%;
}

.manual-review-detail-page .manual-review-page__tabs .statusTitleTextFontSize {
  font-size: var(--caseSubHeading-FontSize);
}
.manual-review-detail-page .manual-review-page__tabs .colwiseLabelValue {
  display: flex;
  flex-direction: row;
  gap: 5px;
}
.manual-review-detail-page .manual-review-page__tabs .rowwiseLabelValue .value {
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}
.manual-review-detail-page .manual-review-page__tabs .displayText.primaryColor {
  color: var(--popupTItleColor);
}
/* Inverted color tab control -- start */
.manual-review-detail-page .manual-review-page__tabs .tabHeader {
  background-color: unset;
}
.manual-review-detail-page
  .manual-review-page__tabs
  .tabControl
  .tabHeader
  .MuiButtonBase-root.Mui-selected {
  border-bottom: var(--unStyledSwitchColor) 4px solid;
}
.manual-review-detail-page
  .manual-review-page__tabs
  .tabControl
  .tabHeader
  .tabTitleButton {
  font-size: var(--caseSubHeading-FontSize);
}
.manual-review-detail-page
  .manual-review-page__tabs
  .tabHeader
  .tabTitleButton.contained {
  background: unset;
  color: var(--listHeaderFontColor);
}
.manual-review-detail-page
  .manual-review-page__tabs
  .tabHeader
  .Mui-selected
  .tabTitleButton.contained {
  /* background: unset; */
  color: var(--templateHeaderSelectedFontColor);
}
.manual-review-detail-page
  .manual-review-page__tabs
  .tabControl
  .tabHeader
  .tabTitleButton {
  padding-right: 0px;
  padding-left: 0px;
}
.manual-review-detail-page
  .manual-review-page__tabs
  .tabControl
  .MuiTabs-flexContainer {
  gap: 1.5rem;
}
.manual-review-detail-page
  .manual-review-page__tabs
  .tabControl
  .tabHeader
  .tabTitleButton.text {
  color: var(--tooltipBackgroundColor);
  font-size: var(--caseSubHeading-FontSize);
}
.manual-review-detail-page .manual-review-page__tabs .sectionTitle {
  font-family: var(--default-FontName);
  font-size: var(--caseSubHeading-FontSize);
  color: var(--gridTitleFontColor);
  font-weight: var(--gridTitleFontWeight);
  line-height: 32px;
}
.manual-review-detail-page
  .manual-review-page__tabs
  .tabHeader
  .Mui-selected
  .tabTitleButton.contained {
  padding-bottom: 6px;
}
.manual-review-detail-page .manual-review-page__tabs,
.AddressTabListPage {
  height: 100%;
}
.manual-review-detail-page .manual-review-page__tabs .imageWithIconDiv {
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
}
.manual-review-detail-page .manual-review-page__status-badge {
  height: 24px;
  border-radius: 100px;
  padding: 3px 8px;
  background-color: var(--Freeflow-Phase-1-family-color, #1f3c88);
  color: var(--button-secondary-color);
  font-size: 13px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  line-height: 18px;
}

.manual-review-detail-page .manual-review-page__status-badge.on-hold {
  background-color: var(--on-hold-status-color) !important;
  color: var(--button-secondary-color) !important;
  width: 70px;
}
.manual-review-detail-page .manual-review-page__status-badge.discarded {
  background-color: var(--inputControlDisabledBgColor) !important;
  color: var(--submenufontcolour) !important;
  width: 90px;
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/manualReviewTab/ManualReviewDetailPage.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;EACzC,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA,wCAAwC;AACxC;EACE,uBAAuB;AACzB;AACA;;;;;EAKE,mDAAmD;AACrD;AACA;;;;;EAKE,yCAAyC;AAC3C;AACA;;;;EAIE,iBAAiB;EACjB,iCAAiC;AACnC;AACA;;;;;EAKE,uBAAuB;EACvB,6CAA6C;AAC/C;AACA;;;;;EAKE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;;;EAIE,WAAW;AACb;AACA;;;;;EAKE,oCAAoC;EACpC,yCAAyC;AAC3C;AACA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,gCAAgC;EAChC,uCAAuC;EACvC,iBAAiB;AACnB;AACA;;;;;EAKE,mBAAmB;AACrB;AACA;;EAEE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,+DAA+D;EAC/D,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,wDAAwD;EACxD,+CAA+C;EAC/C,WAAW;AACb;AACA;EACE,+DAA+D;EAC/D,0CAA0C;EAC1C,WAAW;AACb","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.manual-review-detail-page {\n  height: 100%;\n  display: grid;\n  grid-template-rows: auto 1fr;\n  padding: 24px 30px;\n}\n\n.manual-review-detail-page .manual-review-page__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.manual-review-detail-page .manual-review-page__header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.manual-review-detail-page .manual-review-page__title {\n  margin: 0;\n  font-size: var(--sub-header-FontSize);\n  font-weight: var(--header-FontWeight);\n  color: var(--countValueFontColor);\n}\n\n.manual-review-detail-page .manual-review-page__back-icon {\n  cursor: pointer;\n}\n\n.manual-review-detail-page .manual-review-page__header-right {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n}\n.manual-review-detail-page .manual-hold-Icon.reactSvgDiv div {\n  display: flex;\n  align-items: center;\n}\n\n.manual-review-detail-page .manual-review-page__action-label {\n  color: var(--popupTItleColor);\n  font-weight: var(--header-FontWeight);\n}\n\n.manual-review-detail-page .manual-review-page__status {\n  font-size: var(--caseSubHeading-FontSize);\n  color: var(--popupTItleColor);\n  font-weight: var(--header-FontWeight);\n}\n\n.manual-review-detail-page .manual-review-page__tabs {\n  height: 100%;\n  overflow: hidden;\n}\n\n.manual-review-detail-page .manual-review__events-tab {\n  height: 100%;\n}\n\n.manual-review-detail-page .manual-review-page__tabs .statusTitleTextFontSize {\n  font-size: var(--caseSubHeading-FontSize);\n}\n.manual-review-detail-page .manual-review-page__tabs .colwiseLabelValue {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n}\n.manual-review-detail-page .manual-review-page__tabs .rowwiseLabelValue .value {\n  word-break: break-word;\n  overflow-wrap: break-word;\n  white-space: normal;\n}\n.manual-review-detail-page .manual-review-page__tabs .displayText.primaryColor {\n  color: var(--popupTItleColor);\n}\n/* Inverted color tab control -- start */\n.manual-review-detail-page .manual-review-page__tabs .tabHeader {\n  background-color: unset;\n}\n.manual-review-detail-page\n  .manual-review-page__tabs\n  .tabControl\n  .tabHeader\n  .MuiButtonBase-root.Mui-selected {\n  border-bottom: var(--unStyledSwitchColor) 4px solid;\n}\n.manual-review-detail-page\n  .manual-review-page__tabs\n  .tabControl\n  .tabHeader\n  .tabTitleButton {\n  font-size: var(--caseSubHeading-FontSize);\n}\n.manual-review-detail-page\n  .manual-review-page__tabs\n  .tabHeader\n  .tabTitleButton.contained {\n  background: unset;\n  color: var(--listHeaderFontColor);\n}\n.manual-review-detail-page\n  .manual-review-page__tabs\n  .tabHeader\n  .Mui-selected\n  .tabTitleButton.contained {\n  /* background: unset; */\n  color: var(--templateHeaderSelectedFontColor);\n}\n.manual-review-detail-page\n  .manual-review-page__tabs\n  .tabControl\n  .tabHeader\n  .tabTitleButton {\n  padding-right: 0px;\n  padding-left: 0px;\n}\n.manual-review-detail-page\n  .manual-review-page__tabs\n  .tabControl\n  .MuiTabs-flexContainer {\n  gap: 1.5rem;\n}\n.manual-review-detail-page\n  .manual-review-page__tabs\n  .tabControl\n  .tabHeader\n  .tabTitleButton.text {\n  color: var(--tooltipBackgroundColor);\n  font-size: var(--caseSubHeading-FontSize);\n}\n.manual-review-detail-page .manual-review-page__tabs .sectionTitle {\n  font-family: var(--default-FontName);\n  font-size: var(--caseSubHeading-FontSize);\n  color: var(--gridTitleFontColor);\n  font-weight: var(--gridTitleFontWeight);\n  line-height: 32px;\n}\n.manual-review-detail-page\n  .manual-review-page__tabs\n  .tabHeader\n  .Mui-selected\n  .tabTitleButton.contained {\n  padding-bottom: 6px;\n}\n.manual-review-detail-page .manual-review-page__tabs,\n.AddressTabListPage {\n  height: 100%;\n}\n.manual-review-detail-page .manual-review-page__tabs .imageWithIconDiv {\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  align-items: center;\n}\n.manual-review-detail-page .manual-review-page__status-badge {\n  height: 24px;\n  border-radius: 100px;\n  padding: 3px 8px;\n  background-color: var(--Freeflow-Phase-1-family-color, #1f3c88);\n  color: var(--button-secondary-color);\n  font-size: 13px;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  line-height: 18px;\n}\n\n.manual-review-detail-page .manual-review-page__status-badge.on-hold {\n  background-color: var(--on-hold-status-color) !important;\n  color: var(--button-secondary-color) !important;\n  width: 70px;\n}\n.manual-review-detail-page .manual-review-page__status-badge.discarded {\n  background-color: var(--inputControlDisabledBgColor) !important;\n  color: var(--submenufontcolour) !important;\n  width: 90px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
